import { render, staticRenderFns } from "./site-development-index.vue?vue&type=template&id=20425b97"
import script from "./site-development-index.vue?vue&type=script&lang=js"
export * from "./site-development-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports